import React, { useState, useEffect, Fragment } from "react";
import { useParams, useHistory, useLocation, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { Helmet } from "react-helmet";

const AccountBrand = (props) => {
  const history = useHistory();
  const { pathname } = useLocation();
  const { user } = useSelector((state) => state.auth);
  const [state, setState] = useState(null);

  useEffect(() => {
    if (user) {
      if (pathname.includes(user?.user?.role)) {
        setState(user);
      } else {
        history.replace(`/dashboard/${user?.user?.role}`);
      }
    }
  }, [user, pathname]);

  return (
    <Fragment>
      <Helmet>
        <title>eksplode! | Account Info</title>
      </Helmet>
      {state && (
        <div className="dashboard">
          <div className="page-title">
            <h2>My Dashboard</h2>
          </div>
          <div className="welcome-msg">
            <h3>
              <small>Hello, </small>
              {`${state.user.first_name} ${state.user.last_name}`}
            </h3>
            <p>
              From your My Account Dashboard you have the ability to view a
              snapshot of your recent account activity and update your account
              information.
            </p>
          </div>
          <div className="box-account box-info">
            <div className="box-head">
              <h2>Account Information</h2>
            </div>
            <div className="row">
              <div className="col-sm-4">
                <div className="box">
                  <div className="box-title">
                    <h3>Contact Information</h3>
                  </div>
                  <div className="box-content">
                    {pathname.includes("customer") && (
                      <h6>{state.user.phone}</h6>
                    )}
                    <h6>{state.user.email}</h6>
                    <h6>
                      <Link to={`${pathname}/change-password`}>
                        Change Password
                      </Link>
                    </h6>
                  </div>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="box">
                  <div className="box-title">
                    <h3>eksplode! Code</h3>
                  </div>
                  <div className="box-content">
                    <h6>{state.user.eksplode_code}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default AccountBrand;
